﻿export class ColorWheelOption {
    name: string;
    fourDigitCode: string;
    baseColor: string;
}
